import React from 'react'
import unavailbleServiceImg from '../../../media/images/servicesAssets/unavailbleServiceImg.png'
import { useSelector } from 'react-redux';


const CustomTable = ({
    elements,
    onRowClick,
    tableType = 2
}) => {
    const { role, permissionArr } = useSelector((state) => state.user);
    const permissionArray = permissionArr[0] || [];

    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? "am" : "pm";
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }


    return (
        <>
            {/* table == 1 service request table */}
            {tableType == 1 && elements &&
                <>

                    {(elements)?.map((data, id) => (
                        <>
                            <div
                                key={id}
                                className="row mx-0 mt-2 p-2 shadow-lg   cursor-pointer"
                                onClick={() => onRowClick(data)}
                                style={{
                                    backgroundColor: "rgba(251, 252, 255, 1)",
                                    borderRadius: '16px',
                                }}
                            >
                                <div className="col-12">
                                    <div
                                        className="row mx-0 overlay-action-btn"
                                        style={{
                                            borderRadius: '16px',
                                        }}
                                    >

                                        <div className='col-12 px-0 d-flex'>

                                            {/* image */}
                                            <div
                                                className=" d-flex justify-content-center align-items-center border border-light"
                                                style={{ height: '120px', borderRadius: '9px' }}
                                            >
                                                {data.image_url ? (
                                                    <img
                                                        src={data.image_url}
                                                        className=""
                                                        style={{ height: '100%', width: '110px', objectFit: "cover", borderRadius: '9px' }}
                                                        alt=""
                                                    />
                                                ) : (

                                                    <img
                                                        src={unavailbleServiceImg}
                                                        className=""
                                                        style={{ height: '100%', width: '95px', objectFit: "", borderRadius: '9px' }}
                                                        alt=""
                                                    />

                                                    // <i
                                                    //     style={{ fontSize: "20px" }}
                                                    //     className="bi bi-images"></i>
                                                )}
                                            </div>

                                            {/* Content */}
                                            <div className=" px-3 pb-1 w-100">

                                                <div className="d-flex w-100 align-items-center justify-content-between fs-7 mb-1">
                                                    <div className="me-1">
                                                        <span
                                                            className=""
                                                            style={{
                                                                color: "gray !important",
                                                            }}
                                                        >
                                                            Created: {` `}

                                                            <strong>
                                                                {`${data?.created_date_dtm ?
                                                                    new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                        hour12: true
                                                                    }).format(
                                                                        data?.created_date_dtm * 1000
                                                                    ) : '-'}`}
                                                            </strong>
                                                        </span>
                                                    </div>
                                                    <div className=" d-flex justify-content-end">
                                                        <span className="">#{data?.display_id_int}</span>
                                                    </div>
                                                </div>

                                                {/* Problem description here hide for now */}
                                                {/* <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <span
                                                            className="fs-6 text-black "
                                                            style={{ fontWeight: "800", color: "black" }}>
                                                            {data?.msg_chr ? data?.msg_chr : data?.problem_description_chr === ("" || null) ? "Problem description not specified" : data?.problem_description_chr}
                                                        </span>
                                                    </div>
                                                </div> */}

                                                {data.category_display_name_chr !== ("" || null) ?
                                                    <div className="row mb-1">
                                                        <div className="col-12">
                                                            <span
                                                                className="text-black "
                                                                style={{}}
                                                            >
                                                                {`${data.category_display_name_chr}`}
                                                            </span>
                                                        </div>
                                                    </div> : <></>
                                                }

                                                {((data.product_type_chr !== "null") && (data.product_type_chr !== null) && (data.product_type_chr !== "")) ?
                                                    <div className="row mb-1">
                                                        <div className="col-12 ">
                                                            <span
                                                                className="text-black "
                                                                style={{}}
                                                            >
                                                                {`${data.product_type_chr}`}
                                                            </span>
                                                        </div>
                                                    </div> : <></>
                                                }

                                                {(permissionArray.includes(`CONNECT TO PRO`)) && <>

                                                    <div className="row mb-1">
                                                        <div className="col-12 ">
                                                            <span
                                                                className="text-black "
                                                                style={{}}
                                                            >
                                                                <strong>Pro : </strong> {` `}
                                                                {(Object.keys(data?.latest_created_call_details)?.length) > 0 ? <>{`${data?.latest_created_call_details?.joinee_name_chr ? data?.latest_created_call_details?.joinee_name_chr?.trim()?.split(/\s+/)[0] : ''}`}</> : <>{`Unassigned`}</>}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </>}


                                                {(permissionArray.includes(`CONNECT TO PRO`)) && <>

                                                    <div className="row mb-1">
                                                        <div className="col-12 ">
                                                            <span
                                                                className="text-black "
                                                                style={{}}
                                                            >


                                                                {data?.summary_meta_data ?
                                                                    (() => {
                                                                        try {
                                                                            const finalObjectTwo = (JSON.parse(data?.summary_meta_data));
                                                                            let finalObject = {};

                                                                            // if(!Object.keys(finalObjectTwo).length > 0) {
                                                                            if (typeof (finalObjectTwo) === 'string') {
                                                                                finalObject = JSON.parse(finalObjectTwo);
                                                                            }

                                                                            // console.log(finalObject, "finalObject");
                                                                            // console.log(finalObjectTwo, "finalObjectTwo");

                                                                            let proRecommendedSolution = "";

                                                                            if (Object.keys(finalObject).length > 0) {
                                                                                proRecommendedSolution = (finalObject?.pro_check_info?.pro_recommended_solution || 0);
                                                                            } else if (Object.keys(finalObjectTwo).length > 0) {
                                                                                proRecommendedSolution = (finalObjectTwo?.pro_check_info?.pro_recommended_solution || 0);
                                                                            } else {
                                                                                proRecommendedSolution = 0;
                                                                            }
                                                                            return <>
                                                                                {proRecommendedSolution === 1 ? <> <strong>Type : </strong> {` `} {`Check-up`}</> :
                                                                                    proRecommendedSolution === 2 ? <> <strong>Type : </strong> {` `} {`DIY Remote Pro`}</> :
                                                                                        proRecommendedSolution === 3 ? <> <strong>Type : </strong> {` `} {`Local Pro`}</> : <> <strong>Fix Plan : </strong> {` `} {`Not Selected`}</>}
                                                                            </>;
                                                                        } catch {
                                                                            return <> <strong>Fix Plan : </strong> {` `} {`Not Selected`}</>;
                                                                        }
                                                                    })() :
                                                                    <>
                                                                        <strong>Fix Plan : </strong> {` `} {`Not Selected`}
                                                                    </>
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </>}


                                                <div className="row">

                                                    <div className="col-12 d-flex">
                                                        <div className="fs-7 border border-light px-3 py-1 rounded-pill">
                                                            <span
                                                                className='font-w700'
                                                                style={{
                                                                    color: (data.ticket_status_ysn === 0) ? "rgba(45, 204, 99, 1)" :
                                                                        (data.ticket_status_ysn === 1 || data.ticket_status_ysn === 5) ? "blue" :
                                                                            data.ticket_status_ysn === 2 ? "orange" :
                                                                                (data.ticket_status_ysn === 4 || data.ticket_status_ysn === 6 || data.ticket_status_ysn === 7) ? "red" : '',
                                                                }}
                                                            >
                                                                {/* {data.ticket_status_ysn === 0 && "Closed"}
                                                            {data.ticket_status_ysn === 1 && "Open"}
                                                            {data.ticket_status_ysn === 2 && "Work in progress"}
                                                            {data.ticket_status_ysn === 4 && "Unresolved"}
                                                            {data.ticket_status_ysn === 5 && "Re-open"}
                                                            {data.ticket_status_ysn === 6 && "Incomplete"}
                                                            {data.ticket_status_ysn === 7 && "Cancelled"} */}
                                                                {data?.status_display_name_chr}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {false &&
                                                        <div className="col-6 d-flex justify-content-end">

                                                            {data.category_display_name_chr !== ("" || null) ?
                                                                <span
                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                    style={{
                                                                        background: "rgba(79, 93, 116, 1)",
                                                                    }}>
                                                                    {`${data.category_display_name_chr} ${((data.product_type_chr !== "null") && (data.product_type_chr !== null) && (data.product_type_chr !== "")) ? ` / ${data.product_type_chr}` : ''}`}
                                                                </span> :
                                                                <span
                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                    style={{
                                                                        background: 'rgba(199, 212, 234, 1)'
                                                                    }}>
                                                                    {`No category`}
                                                                </span>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>




                                    </div>
                                </div>
                            </div>
                        </>
                    ))}

                </>
            }


            {/* table == 2 Reviews and ratings table */}
            {tableType == 2 &&
                <>
                    {(elements).map((data, id) => (
                        <>
                            <div
                                className="row mx-0"
                                style={{ borderBottom: "1px solid rgba(241, 241, 241, 1)" }}>
                                <div className="col-12 ">
                                    <div
                                        className="row mx-0 overlay-action-btn"
                                    >
                                        <div className="col-12 p-2 d-flex align-items-center">
                                            <div
                                                className="align-items-center d-flex fs-4 justify-content-center rounded-circle text-white fw-bold"
                                                style={{ background: "#565656", height: '50px', width: '50px' }}
                                            >
                                                <span className="d-flex align-items-center">
                                                    {data?.rating_value_int}
                                                    <i class="bi bi-star fs-6 ps-1"></i>
                                                </span>
                                            </div>
                                            <div className="px-3 pb-1">
                                                <div className="row mb-2 ">
                                                    <div className="col-12 px-0">
                                                        <span
                                                            className="font-w500 fs-6 pt-2">
                                                            {/* {formatUnixTimestamp(
                                                                data?.created_date_dtm
                                                            )} */}

                                                            {`${data?.created_date_dtm ?
                                                                new Intl.DateTimeFormat("en-US", {
                                                                    year: "numeric",
                                                                    month: "short",
                                                                    day: "numeric",
                                                                    hour: 'numeric',
                                                                    minute: 'numeric',
                                                                    hour12: true
                                                                }).format(
                                                                    data?.created_date_dtm * 1000
                                                                ) : '-'}`}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-12 ">
                                                        <span
                                                            className="fs-6 text-black font-w600"
                                                        >
                                                            {data?.comment_chr ? data?.comment_chr : "Description not specified"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <span>{"Given by: "}</span>
                                                        <span className="text-black font-w600">{data?.given_by_name_chr === ("" || null) ? "Name not specified" : data?.given_by_name_chr}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))}
                </>
            }

            {/* table == 1 service request table */}
            {tableType == 3 && elements &&
                <>

                    {(elements)?.map((data, id) => (
                        <>
                            <div
                                key={id}
                                className="row mx-0 mt-2 p-2 shadow-lg   cursor-pointer"
                                onClick={() => onRowClick(data)}
                                style={{
                                    backgroundColor: "rgba(251, 252, 255, 1)",
                                    borderRadius: '16px',
                                }}
                            >
                                <div className="col-12">
                                    <div
                                        className="row mx-0 overlay-action-btn"
                                        style={{
                                            borderRadius: '16px',
                                        }}
                                    >

                                        <div className='col-12 px-0 d-flex'>

                                            {/* image */}
                                            <div
                                                className=" d-flex justify-content-center align-items-center border border-light"
                                                style={{ height: '95px', borderRadius: '9px' }}
                                            >
                                                {data.image_url ? (
                                                    <img
                                                        src={data.image_url}
                                                        className=""
                                                        style={{ height: '100%', width: '110px', objectFit: "cover", borderRadius: '9px' }}
                                                        alt=""
                                                    />
                                                ) : (

                                                    <img
                                                        src={unavailbleServiceImg}
                                                        className=""
                                                        style={{ height: '100%', width: '110px', objectFit: "", borderRadius: '9px' }}
                                                        alt=""
                                                    />

                                                    // <i
                                                    //     style={{ fontSize: "20px" }}
                                                    //     className="bi bi-images"></i>
                                                )}
                                            </div>

                                            {/* Content */}
                                            <div className=" px-3 pb-1 w-100">
                                                <div className="row  " >
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <span
                                                            className=" pt-2"
                                                            style={{
                                                                color: "gray !important",
                                                                fontSize: "9px",
                                                            }}>
                                                            {/* {new Date(
                                                                data?.created_date_dtm * 1000
                                                            ).toLocaleString("en-US", {
                                                                month: "short",
                                                                day: "numeric",
                                                                year: "numeric",
                                                            })} */}

                                                            {`${data?.created_date_dtm ?
                                                                new Intl.DateTimeFormat("en-US", {
                                                                    year: "numeric",
                                                                    month: "short",
                                                                    day: "numeric",
                                                                    hour: 'numeric',
                                                                    minute: 'numeric',
                                                                    hour12: true
                                                                }).format(
                                                                    data?.created_date_dtm * 1000
                                                                ) : '-'}`}
                                                        </span>
                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-12 mb-2">

                                                        <span
                                                            className="fs-6 text-black "
                                                            style={{ fontWeight: "800", color: "black" }}>
                                                            {data?.project_title_chr}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 mb-2">
                                                        <span
                                                            className="fs-6 text-black "
                                                            style={{ color: "black" }}>
                                                            Steps :    &nbsp;
                                                        </span>
                                                        <span
                                                            className="fs-6 text-black "
                                                            style={{ fontWeight: "800", color: "black" }}>
                                                            {data?.step_count}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 mb-2">
                                                        <span
                                                            className="fs-6 text-black "
                                                            style={{ color: "black" }}>
                                                            Progress :    &nbsp;
                                                        </span>
                                                        <span
                                                            className="fs-6 text-black "
                                                            style={{ fontWeight: "800", color: "black" }}>
                                                            {data?.project_completion_progress_in_percent}%
                                                        </span>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>




                                    </div>
                                </div>
                            </div>
                        </>
                    ))}

                </>
            }

        </>
    )
}

export default CustomTable